 const heroBanner = document.querySelector('[js-hero-banner]');
 if (heroBanner) {
  const heroBannerSlider = new Swiper("[js-hb-banner-slider]", {
    centeredSlides: true,
    slidesPerView: 1,
    grabCursor: true,
    freeMode: false,
    mousewheel: false,
    keyboard: {
      enabled: true
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: false,
      clickable: true
    }
  });

  heroBannerSlider.on('slideChange', updatePaginationPosition);
  updatePaginationPosition();

  function updatePaginationPosition() {
    if(document.documentElement.clientWidth > 767) return;
    const activeSlide = heroBannerSlider.slides[heroBannerSlider.activeIndex];
    const slideHeight = activeSlide.clientHeight;
    const lastImgEl = activeSlide.querySelector('[js-last-image]');
    const pagination = heroBanner.querySelector('[js-pagination]');

    if (pagination) {
      pagination.style.top = `${slideHeight - lastImgEl.clientHeight - 40}px`;
    }
  }
}

const shouldInitializeSwiper = document.querySelector('[js-collection-list]'); 
if (shouldInitializeSwiper) {
  const myCustomSwiper = new Swiper("[js-collection-silder]", {
    slidesPerView: 3,
    spaceBetween: 16,
    watchSlidesProgress: true,
    watchOverflow:!0,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: true, 
    breakpoints: {
      0: {
        slidesPerView: "auto",
        spaceBetween: 12,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

}

if(window.innerWidth > 768) {
const shouldInitializeSwiper2 = document.querySelector('[Index-js-collection-list-only]'); 
if (shouldInitializeSwiper2) {
  const myCustomSwiper = new Swiper("[Index-js-collection-list-only-silder]", {
    slidesPerView: 4,
    spaceBetween: 16,
    watchSlidesProgress: true,
    watchOverflow:!0,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: true, 
    breakpoints: {
      0: {
        slidesPerView: "auto",
        spaceBetween: 12,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      990: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  });
}
}

if (window.innerWidth < 768) {
  const imageSlider = new Swiper('[js-hb-image-slider]', {
      slidesPerView: 1,
      pagination: {
          el: '.swiper-pagination',
          clickable: true
      },
      spaceBetween: 20
  });
}
const teamMember = document.querySelector('[js-team]');
if (teamMember) {
  if (window.innerWidth < 768) {
    const imageSlider = new Swiper('[hb-team-member-slider]', {
        slidesPerView: 'auto',
        spaceBetween: 18
    });
  }
}

const featuredCollectionSlider = new Swiper('[hb_js_featured_collection]', {    
  slidesPerView: 4, 
  spaceBetween: 16,       
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  freeMode:!0, 
  mousewheel:{
      forceToAxis:!0,
      invert: 0,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
})

const featuredProductSlider = new Swiper('[js-featured_products]', {
  slidesPerView: 4,
  spaceBetween: 14,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    360: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
});
function productModelSlider() {
  new Swiper('[js-product-model-slider]', {
    slidesPerView: 3.1,
    spaceBetween: 16,
    watchSlidesProgress: true,
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    freeMode:!0, 
    mousewheel:{
        forceToAxis:!0,
        invert: 0,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 1.8,
        spaceBetween: 16,
      },
      990: {
        slidesPerView: 2.1,
        spaceBetween: 16,
      },
      1201: {
        slidesPerView: 3.1,
        spaceBetween: 16,
      },
    },
  });
  
  let zoomActive = null;

  document.querySelectorAll('.zoomable-container').forEach(container => {
    const image = container.querySelector('.zoomable-image');
    container.addEventListener('click', function (event) {
      if (zoomActive && zoomActive !== container) {
        zoomActive.classList.remove('zoom-active');
      }
      if (!container.classList.contains('zoom-active')) {
        container.classList.add('zoom-active');
        zoomActive = container;
      } else {
        container.classList.remove('zoom-active');
        zoomActive = null;
      }
    });

    container.addEventListener('mousemove', function (event) {
      if (container.classList.contains('zoom-active')) {
        const rect = container.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
         if(x < 100 && x > 0 && y < 100 && y > 0) {
            image.style.transformOrigin = `${x}% ${y}%`;
          }
      }
    });
  
    container.addEventListener('touchmove', function (event) {
      if (container.classList.contains('zoom-active')) {
        const rect = container.getBoundingClientRect();
        const touch = event.touches[0];
        const x = ((touch.clientX - rect.left) / rect.width) * 100;
        const y = ((touch.clientY - rect.top) / rect.height) * 100;
        if(x < 100 && x > 0 && y < 100 && y > 0) {
          image.style.transformOrigin = `${x}% ${y}%`;
        }
      }
    });
  });
  
  document.addEventListener('click', function (event) {
    if (zoomActive && !event.target.closest('.zoomable-container')) {
      zoomActive.classList.remove('zoom-active');
      zoomActive = null;
    }
  });
  
}
productModelSlider();
document.addEventListener('productModelSlider:init', productModelSlider);
const recomendationSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 14,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
};
const recentlyViewSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 14,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    360: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
};

// Changing the color of a combined listing swaps the whole `main` for another
// product's markup, so the sliders have to be built again on the new nodes.
function recomendationSlider(event) {
  const root = event?.detail?.container || document;
  root.querySelectorAll('[js-recomendation-products]').forEach((slider) => {
    if (!slider.swiper) new Swiper(slider, recomendationSliderOptions);
  });
  root.querySelectorAll('[js-recently-view-slider]').forEach((slider) => {
    if (!slider.swiper) new Swiper(slider, recentlyViewSliderOptions);
  });
}

// Slides that arrive after the slider was built (recently viewed products are
// fetched one by one) need the slider to recalculate.
function updateRecomendationSlider(event) {
  const root = event?.detail?.container || document;
  root
    .querySelectorAll('[js-recomendation-products], [js-recently-view-slider]')
    .forEach((slider) => slider.swiper?.update());
}

recomendationSlider();
document.addEventListener('recomendation:init', recomendationSlider);
document.addEventListener('recomendation:update', updateRecomendationSlider);

if (window.innerWidth > 768) {
const outpicksSlider = new Swiper('[js-hb-ourpicks-slider]', {    
  slidesPerView: 4,  
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  freeMode:!0,
  mousewheel:{
      forceToAxis:!0,
      invert: 0,
  },
  breakpoints: {
    360: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 14,
    },
  },
})
}

let quickAddSwiperInstance;

function quickAddSlider() {
  quickAddSwiperInstance = new Swiper('.quick-add-modal__content [js-quick-add-slider]', {
    slidesPerView: 1,
    spaceBetween: 16,
    watchSlidesProgress: true,
    draggable: true,
    autoHeight: false,
    watchOverflow: true,
    threshold: 10,
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
      invert: false,
    },
    navigation: {
      nextEl: '.swiper-quick-button-next',
      prevEl: '.swiper-quick-button-prev',
    },
  });
}

function destroyQuickAddSlider() {
  if (quickAddSwiperInstance) {
    quickAddSwiperInstance.destroy(true, true);
    quickAddSwiperInstance = null;
  }
}

document.addEventListener('quickAddSlider:init', quickAddSlider);
document.addEventListener('quickAddSlider:destroy', destroyQuickAddSlider);